import { Button, Paper, Stack, Typography } from "@mui/material";
import { useContext } from "react";

import { AuthContext } from "~/auth/AuthProvider";
import Config from "~/config";

/** 403 page rendered when an authenticated user lacks authorization for a guarded route. */
const Forbidden = () => {
	const auth = useContext(AuthContext);

	return (
		<Paper sx={{ p: 3, textAlign: "center", maxWidth: 420, mx: "auto", mt: 8 }}>
			<Stack spacing={2} alignItems="center">
				<Typography variant="h6">Please contact your manager for assistance</Typography>
				<Button color="primary" variant="contained" onClick={() => auth.redirectToLogout()}>
					Try Logging in Again
				</Button>
				<Typography variant="caption" color="text.secondary">
					Build Version: {Config.buildVersion}
				</Typography>
			</Stack>
		</Paper>
	);
};

export default Forbidden;
